import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NbButtonModule, NbCardModule, NbDialogRef, NbDialogService, NbInputModule, NbSpinnerModule } from '@nebular/theme';

import { BaseFormComponent } from '../../side-forms/base-form/base-form.component';

@Component({
  selector: 'app-gamme-site-comment-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, NbCardModule, NbButtonModule, NbInputModule, NbSpinnerModule],
  styleUrls: ['./gamme-site-comment-dialog.component.scss'],
  template: `
    <form (ngSubmit)="onSubmit()">
      <nb-card [ngClass]="customNbCardClass">
        <nb-card-header class="header">
          <span></span>
          <div class="title">{{ label }}</div>
          <span class="close-btn" (click)="close()">
            <i class="fal fa-x"></i>
          </span>
        </nb-card-header>
        <nb-card-body class="body">
          <div *ngIf="commentLaw" class="law-text">{{ commentLaw }}</div>
          <textarea
            [(ngModel)]="editedSiteComment"
            name="siteComment"
            [placeholder]="'Add a comment for the site' | translate"
          ></textarea>
        </nb-card-body>
        <nb-card-footer *ngIf="anyFieldValueChanged()" class="administration">
          <button nbButton type="submit" [disabled]="loading">
            <nb-spinner *ngIf="loading" size="tiny"></nb-spinner>
            {{ 'Save' | translate }}
          </button>
        </nb-card-footer>
      </nb-card>
    </form>
  `,
})
export class GammeSiteCommentDialogComponent extends BaseFormComponent implements OnInit {
  @Input() public label = '';
  @Input() public commentLaw = '';
  @Input() public siteComment = '';

  public editedSiteComment = '';
  public readonly title = '';

  constructor(
    protected override nbDialogRef: NbDialogRef<BaseFormComponent>,
    protected override dialogService: NbDialogService,
    protected override translate: TranslateService,
  ) {
    super(nbDialogRef, dialogService, translate);
  }

  override ngOnInit(): void {
    this.editedSiteComment = this.siteComment;
    this.initializeBackdropClick();
  }

  public anyFieldValueChanged(): boolean {
    return this.editedSiteComment !== this.siteComment;
  }

  public onSubmit(): void {
    this.nbDialogRef.close({ siteComment: this.editedSiteComment });
  }

  public goToAudit(): void {}
  protected setUpAvailableValues(): void {}
}
